import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 实时数据
 **********************************************************************************/
export default {
	/**
	 * 使用mapkey获取实时数据,可以有一个回调
	 * @param {Object} path
	 * @param {Object} mapkey
	 * @param {Object} ticket 标识,可以是自定义的内容,会原样返回
	 * @param {Object} callback
	 */
	getMACRealValueWithIDByMapkey: (mapkey, ticket, success, failure) => {
		Axios.post('/real/getMacRealValue.do', {
			'mapkey': mapkey,
		}, respon => {
			success(respon, ticket)
		}, failure);
	},
	/**
	 * 获取实时值
	 * @param {Object} path
	 * @param {Object} variableNames 通讯变量名
	 * @param {Object} ticket 标识,可以是自定义的内容,会原样返回(放的是时间)
	 * @param {Object} callback
	 */
	getMACRealValueWithID: (variableNames, ticket, success, failure) => {
		Axios.post('/real/getMacRealValue.do', {
			'variableNames': variableNames,
		}, respon => {
			success(respon, ticket)
		}, failure);
	},
	getLimitMap: (variableNames, success, failure) => {
		Axios.post('/variable/getLimitMap.do', {
			variableNames,
		}, success, failure);
	},
	/**
	 *实时值修改
	 */
	 getWriteValues: (name,value,success, failure) => {
		Axios.post('/real/getWriteValues.do', {
			name,
			value,
		}, success, failure)
	},
}